
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"73","height":"73","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F8F8F8","d":"M0 0h73v73H0z"}}),_c('path',{attrs:{"d":"M64.936 30.546c0-1.405-1.206-2.546-2.692-2.546h-3.592c-1.486 0-2.692 1.14-2.692 2.546 0 1.405 1.206 2.546 2.692 2.546h.896v10.1c0 1.406 1.206 2.547 2.692 2.547 1.486 0 2.692-1.141 2.692-2.546V30.546h.004s0 .004 0 0zM5.692 33.096c1.487 0 2.692-1.14 2.692-2.546s-1.205-2.546-2.692-2.546S3 29.144 3 30.55s1.205 2.546 2.692 2.546zM53.963 41.395l-1.905-1.802c1.298-1.228 2.106-2.922 2.106-4.799 0-3.748-3.216-6.79-7.18-6.79-1.983 0-3.775.76-5.073 1.988l-10.156 9.6-2.535-2.396 5.122-4.844c.485-.463.787-1.1.787-1.802 0-1.405-1.207-2.546-2.692-2.546a2.78 2.78 0 00-1.906.744l-5.121 4.844-5.122-4.844a2.78 2.78 0 00-1.905-.744c-1.486 0-2.692 1.14-2.692 2.546 0 .702.301 1.339.786 1.802l5.122 4.844-2.535 2.397-8.884-8.403c-.293 1.856-1.844 3.323-3.81 3.604l10.789 10.2c.49.464 1.162.749 1.905.749.743 0 1.416-.285 1.906-.748l4.44-4.2 4.44 4.2c.489.463 1.162.748 1.905.748.743 0 1.416-.285 1.905-.748l12.057-11.403a1.843 1.843 0 011.267-.496c.992 0 1.797.76 1.797 1.698 0 .484-.215.918-.556 1.224l-1.874 1.773a2.485 2.485 0 00-.787 1.802c0 .702.302 1.339.787 1.802l3.806 3.6c1.053.996 2.758.996 3.81 0a2.45 2.45 0 00-.004-3.6z","fill":"#2A958D"}})])
          )
        }
      }
    